// // Use $ instead of jQuery without replacing global $
(function ($) {

    $(window).on("load", function () {
        var hero_image = $('.banner-second-carousel .bg-img img');
        objectFitImages(hero_image);

        $('.banner-second-carousel .slider-wrapper').css({"opacity": 1});

        $('.banner-second-carousel .slider-wrapper .slider').slick({
            arrows: true,
            slidesToShow: 1,
            speed: 800,
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
            infinite: true,
            draggable: true,
            dots: true,
            prevArrow: $('.banner-second-carousel .slide-nav .slide-prev'),
            nextArrow: $('.banner-second-carousel .slide-nav .slide-next'),
            dotsClass: 'dots-container',
            appendDots: $('.dots-wrapper'),
            customPaging : function(slider, i) {
                var thumb = $(slider.$slides[i]).data();
                return '<span class="dots"></span>';
            }
        });
    });

    $('.banner-second-carousel .slider-wrapper').on('afterChange', function(event, slick, currentSlide, nextSlide){

        if( $(".slick-current").hasClass("content-right") ) {
            $(".banner-second-carousel .btn-controls" ).addClass( "arrow-left" );
        }
        else {
            $(".banner-second-carousel .btn-controls" ).removeClass( "arrow-left" );
        }
    });

    if( $(".slick-current .content").hasClass("content-right") ){
        $(".banner-second-carousel .btn-controls" ).addClass("arrow-left");
    }


    $('.banner-second-carousel .slider-wrapper .slider').on('init', function (event, slick) {
        $('.banner-second-carousel .slider-wrapper .slider .item').addClass('active');
    });


  $("body .banner-second-level .form .submit-btn").on('click', function () {
    var text = $('body .banner-second-level .form input').val();
    $('#views-exposed-form-resource-block-1 .form-item-combine input').val(text);
    $('#views-exposed-form-resource-block-1 .form-submit:eq(0)').trigger('click');
  });


  $("body .banner-second-level .form input").on("keyup", function(event) {
    // Number 13 is the "Enter" key on the keyboard
    if (event.keyCode === 13) {
      event.preventDefault();
      var text = $('body .banner-second-level .form input').val();
      // console.log(text);
      $('#views-exposed-form-resource-block-1 .form-item-combine input').val(text);
      $('#views-exposed-form-resource-block-1 .form-submit:eq(0)').trigger('click');
    }
  });

  /* Product-banner */
    $("body .banner-second-level .product-banner .form .submit-btn").on('click', function () {
        var text = $('body .banner-second-level .product-banner .form input').val();
        $('#views-exposed-form-blog-block-2 .form-item-combine input').val(text);
        $('#views-exposed-form-blog-block-2 .form-submit:eq(0)').trigger('click');
    });


    $("body .banner-second-level .product-banner .form input").on("keyup", function(event) {
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13) {
            event.preventDefault();
            var text = $('body .banner-second-level .product-banner .form input').val();
            // console.log(text);
            $('#views-exposed-form-blog-block-2 .form-item-combine input').val(text);
            $('#views-exposed-form-blog-block-2 .form-submit:eq(0)').trigger('click');
        }
    });

    /* Blog-banner */
    $("body .banner-second-level .blog-banner .form .submit-btn").on('click', function () {
        var text = $('body .banner-second-level .blog-banner .form input').val();
        $('#views-exposed-form-blog-block-1 .form-item-combine input').val(text);
        $('#views-exposed-form-blog-block-1 .form-submit:eq(0)').trigger('click');
    });


    $("body .banner-second-level .blog-banner .form input").on("keyup", function(event) {
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13) {
            event.preventDefault();
            var text = $('body .banner-second-level .blog-banner .form input').val();
            // console.log(text);
            $('#views-exposed-form-blog-block-1 .form-item-combine input').val(text);
            $('#views-exposed-form-blog-block-1 .form-submit:eq(0)').trigger('click');
        }
    });


    // /*solution-banner*/
    // $("body .banner-second-level .solution-banner .form .submit-btn").on('click', function () {
    //     var text = $('body .banner-second-level .solution-banner .form input').val();
    //     $('#views-exposed-form-blog-block-2 .form-item-combine input').val(text);
    //     $('#views-exposed-form-blog-block-2 .form-submit:eq(0)').trigger('click');
    // });
    //
    //
    // $("body .banner-second-level .solution-banner .form input").on("keyup", function(event) {
    //     // Number 13 is the "Enter" key on the keyboard
    //     if (event.keyCode === 13) {
    //         event.preventDefault();
    //         var text = $('body .banner-second-level .solution-banner .form input').val();
    //         // console.log(text);
    //         $('#views-exposed-form-blog-block-2 .form-item-combine input').val(text);
    //         $('#views-exposed-form-blog-block-2 .form-submit:eq(0)').trigger('click');
    //     }
    // });

  $(document).ready(function () {
    var banner_second = $('.banner-second-level .bg-img img');
    objectFitImages(banner_second);
  });


})(jQuery);